
import { M_SIPARIS_DETAY } from './../../models/M_SIPARIS_DETAY';

import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Database } from '../database';
import { resolveDefinition } from '../../../node_modules/@angular/core/src/view/util';


// import { M_CLCARD } from '../../models/M_CLCARD';
// import { M_ITEM_PRICELIST } from '../../models/M_ITEM_PRICELIST';
// import { Ortak } from '../../providers/ortak';
// import { _RESULT } from '../../models/_RESULT';
// import { BllDovizCinsi } from '../../providers/bll/bll-doviz-cinsi'
/* 
  Generated class for the BllSiparisDetay provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BllSiparisDetay extends Database {
  constructor() {
    super("M_SIPARIS_DETAY");
  }

  siparisDetayEkle_Temp(kaynakRef: number,itemref:number, miktar: number,  urunAdi: string,kdv: number, siparisID: number,urunfiyati:number,urunmaliyet:number,siparisdurumid:number) {
    return new Promise((resolve, reject) => {
      var eklenecekFiyat: number = 0;
      var siparisDetaySecenekleriJSON = "";
      var aciklama = "";
      

      var siparisDetay = new M_SIPARIS_DETAY();
      
     // siparisDetay.LogicalRef=-1;
      siparisDetay.CariKartID=kaynakRef;
      siparisDetay.Kdv=kdv;
      siparisDetay.Miktar = miktar;
      siparisDetay.siparisID = siparisID;
      siparisDetay.BirimFiyat=urunfiyati;
      siparisDetay.DepoKodu=1;
      siparisDetay.IslemTuru=1;
      siparisDetay.Sign=1;
      siparisDetay.SlsMan="Mobil";
      siparisDetay.Tutar=miktar*urunfiyati;
      siparisDetay.StokKartID=itemref;
      siparisDetay.Maliyet=urunmaliyet;
      siparisDetay.NetFiyat=urunfiyati*kdv/100
      siparisDetay.UrunName=urunAdi;
      siparisDetay.SIPARIS_DURUM_ID=siparisdurumid;
          
      this.add(siparisDetay).then(a => {

        resolve(a);
      }).catch(x => {
        reject(x);
      })

    });
  }
  satinAlmaDetayEkle_Temp(kaynakRef: number,itemref:number, miktar: number,  urunAdi: string,kdv: number, siparisID: number,urunfiyati:number,urunmaliyet:number,siparisdurumid:number,islemyapan:string) {
    return new Promise((resolve, reject) => {
      var eklenecekFiyat: number = 0;
      var siparisDetaySecenekleriJSON = "";
      var aciklama = "";
      var seceneklerString = "";
     
      this.getAll({ siparisID: -999,ItemsRef:itemref}).then(b => {
        var sonuc = <any>b;
       
        if (sonuc.length > 0) {
          sonuc[0].Miktar = sonuc[0].Miktar + parseFloat(miktar.toString());
          this.miktarGuncelle(sonuc[0]).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
        else {
      
          var siparisDetay = new M_SIPARIS_DETAY();
          siparisDetay.CariKartID=kaynakRef;
      siparisDetay.Kdv=urunfiyati*kdv/100;
      siparisDetay.Miktar = miktar;
      siparisDetay.siparisID = siparisID;
      siparisDetay.BirimFiyat=urunfiyati;
      siparisDetay.DepoKodu=0;
      siparisDetay.IslemTuru=1;
      siparisDetay.Sign=0;
      siparisDetay.SlsMan=islemyapan;
      siparisDetay.Tutar=miktar*urunfiyati;
      siparisDetay.StokKartID=itemref;
      siparisDetay.Maliyet=urunmaliyet;
      siparisDetay.NetFiyat=urunfiyati;
      siparisDetay.UrunName=urunAdi;
      siparisDetay.SIPARIS_DURUM_ID=siparisdurumid;
      siparisDetay.CariKartID=1;
      siparisDetay.IskontoOran1=0;
      siparisDetay.IskontoOran2=0;
      siparisDetay.IskontoOran3=0;
      siparisDetay.IskontoTutar=0;
      siparisDetay.AraTutar=urunfiyati-(urunfiyati*kdv/100);
      siparisDetay.KdvOran=18;

          this.add(siparisDetay).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
      });

    });
  }

 
  miktarGuncelle(detay: M_SIPARIS_DETAY) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update M_SIPARIS_DETAY set Miktar = ? where ID = ?", [detay.Miktar, detay.ID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })
    })
  }
  birimFiyatGuncelle(detay: M_SIPARIS_DETAY) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update M_SIPARIS_DETAY set BIRIM_FIYAT = ? where ID = ?", [detay.BirimFiyat, detay.siparisID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })
    })
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-siparis-detay.ts